import { TranslationRepository } from '../data/translation-repository';
import { PreviewInfoResponse, ApplicationType } from '../types/translation-types';

export class GetPreviewInfoUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(applicationType: ApplicationType): Promise<PreviewInfoResponse> {
    return this.repository.getPreviewInfo(applicationType);
  }
}
